import { FormFieldType } from "../../../screens/OfficeInfo/Tabs/OfficeProfileData";
import SelectNew, { SelectOption } from "../../Select/SelectNew";
import Button from "../../Button/Button";
import { PlanFormDataType } from "../../../utils/planConstant";
import { SubscriptionType } from "../../../models/annual-plan.model";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

const Step1 = ({
  formData,
  monthlyOptions,
  yearlyOptions,
  setFormData,
  changeStep,
}: {
  formData: PlanFormDataType[];
  monthlyOptions: SelectOption[];
  yearlyOptions: SelectOption[];
  setFormData: (val: PlanFormDataType[]) => void;
  changeStep: (val?: boolean) => void;
}) => {
  const handleChange = (item: PlanFormDataType, index: number, value: string) => {
    setFormData([...formData.slice(0, index), { ...item, value, valid: true }, ...formData.slice(index + 1)]);
  };

  const validateForm = () => {
    const grouped = formData.reduce<Record<string, PlanFormDataType[]>>((acc, item) => {
      const { testingID } = item;
      if (!testingID) return acc;

      (acc[testingID] ??= []).push(item);
      return acc;
    }, {});

    const visibleItems = formData.filter(item => {
      return !(item.planName && !validPlanNames.includes(item.planName));
    });
    // Check if all visible selects are filled and valid
    const allVisibleValid = visibleItems.every(item => {
      if (item.type === FormFieldType.SelectNew) {
        return item.value && item.valid;
      }
      return true;
    });

    if (!allVisibleValid) return false;
    //enforce group-wise rule
    for (const group of Object.values(grouped)) {
      const hasAnySelected = group.some(item => item.value);
      const allSelectedAndValid = group.every(item => item.value && item.valid);

      if (hasAnySelected && !allSelectedAndValid) {
        return false;
      }
    }
    return true;
  };

  const selectedAnualPlans = useSelector((state: RootState) => state.selectedPlans.selectedPlans);
  const validPlanNames = selectedAnualPlans.map(plan => plan.planName);
  return (
    <>
      <div className="mt-10">
        <h2 className="headline font-bold uppercase">Select Annual Plan Rates</h2>
        <div className="w-full grid sm:grid-cols-2 gap-x-5 mt-4">
          {formData.map((item, index) => {
            const options = item.title.toLocaleLowerCase() === SubscriptionType.Monthly ? monthlyOptions : yearlyOptions;
            const isDisabled = Boolean(item.type === FormFieldType.SelectNew && item.planName && !validPlanNames.includes(item.planName));
            const isSectionDisabled = item.planName && !validPlanNames.includes(item.planName);
            return item.type === FormFieldType.SectionHeader ? (
              <div key={item.id} className={`col-span-2 mt-4 mb-3 ${isSectionDisabled && "hidden"}`}>
                <h2 className="headline font-bold">{item.title}</h2>
              </div>
            ) : (
              <div className={`w-full ${isDisabled && "hidden"}`}>
                <SelectNew
                  title={item.title.charAt(0).toUpperCase() + item.title.slice(1)}
                  required={true}
                  placeHolder={"Select"}
                  onSelect={e => handleChange(item, index, e.target.value)}
                  value={item.value}
                  options={options}
                  isDarkBg
                  disabled={isDisabled}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className="fixed bottom-0 right-0 w-11/12 max-w-120 z-30 bg-docsigna-pink-light border-t">
        <div className="px-8 py-5 flex justify-end">
          <Button onClick={() => changeStep(true)} className="pointer px-5 mr-3" text={"Cancel"} width="fit" variant="Secondary" />
          <div id="save-button">
            <Button disabled={!validateForm()} onClick={() => changeStep()} className="pointer px-5" text={"Next"} width="fit" variant={"Primary"} />
          </div>
        </div>
      </div>
    </>
  );
};
export default Step1;
